import React, { useRef, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Col, Container, Spinner } from 'react-bootstrap'
import "../../styles/multipliers-styles.scss"
import { useFormik } from 'formik'
import FeatherIcon from 'feather-icons-react';
import { setGlobalLoading } from 'redux/actions/actionCommon'

import { formValidationSchema, initialFormValues } from './Includes/FormHelper'
import FormStoreMultiplier from "./Includes/FormStoreMultiplier"
import { Link } from 'react-router-dom'
import { editmultipliers, getMultipliers } from 'utlis/Apis/Multipliers_API'
import { toast } from 'react-toastify'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE_FETCHING_MULTIPLIERS } from 'utlis/AppMessages/AppMessages'
import { MULTIPLIERS_UPDATED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'

function StoreMultiplier(props) {
    // props
    const { authState } = props

    const submitButtonRef = useRef(null)

    // store url
    const [storeUrl] = useStoreUrl()

    const [multipliers, setMultipliers] = useState({})
    const [editButtonDisable, setEditButtonDisable] = useState(false)
    const [editButtonLoading, setEditButtonLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    // const [show, setShow] = useState(false)

    useEffect(() => {
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getMultipliers(headers).then(res => {
            setLoading(loading)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setMultipliers(resData.data)

            }

            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_MULTIPLIERS, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getMultipliers `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setLoading(false)
                }
            })
        })
    }, [authState, loading])

    const onMultipliersFormSubmit = values => {
        if (values) {
            setGlobalLoading(true)
            setEditButtonDisable(true)
            setEditButtonLoading(true)
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            editmultipliers(headers, values).then(res => {
                const multiplierData = res.data
                if (multiplierData && multiplierData.success) {
                    toast.success(MULTIPLIERS_UPDATED_SUCCESSFULLY, {
                        autoClose: 3000
                    })
                }
                setGlobalLoading(false)
                setEditButtonDisable(false)
                setEditButtonLoading(false)

            })
                .catch(err => {
                    console.log(`${ERROR_WHILE__NAME} editmultipliers `, err.message)
                    toast.dismiss();
                    toast.error(UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500,
                        onClose: () => {
                            setGlobalLoading(false)
                        }
                    })
                })
        }
    }

    const formik = useFormik({
        initialValues: initialFormValues(multipliers),
        validationSchema: formValidationSchema,
        onSubmit: onMultipliersFormSubmit,
        enableReinitialize: true
    })

    const handleFormSubmission = (ev) => {
        ev.preventDefault()
        submitButtonRef.current.click()
    }

    return (
        <section id="app-multipliers" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-multipliers">
                    <Link
                        className="st-btn st-btn-link text-primary border-light bg-transparent no-min-width st-btn-sm p-0 min-height-auto"
                        to={storeUrl + "/catalog/multipliers"}
                    >
                        <FeatherIcon
                            icon="arrow-left"
                            size="14"
                            className="icon me-2" />
                        <span>Back</span>
                    </Link>
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Store Multiplier</p>
                        <p className="app-desc">Setup of Store Multipliers</p>
                    </div>
                    <Col xs={12} md={12} lg={7} className="px-0">
                        <div className="app-card">
                            <div className="app-card-content border st-default-rounded-block pad-12-T pad-12-B pad-12-R pad-12-L">
                                <div className="app-card">
                                    <div className="app-card-content  pad-20-LR pad-20-T">
                                        <Col xs={12} md={9} lg={11} className="px-0">
                                            <form
                                                onSubmit={formik.handleSubmit}
                                                noValidate
                                                autoComplete="off">
                                                <FormStoreMultiplier
                                                    formik={formik}
                                                // show={show}
                                                />
                                                <button
                                                    ref={submitButtonRef}
                                                    type="submit"
                                                    id="customerAddress"
                                                    className="d-none">submit</button>
                                            </form>
                                            <div className="d-flex justify-content-end">
                                                <Col xs={12} md={9} lg={8} className="me-3">
                                                    <div className="cats-all-btns-inner d-flex flex-wrap align-items-center justify-content-between">
                                                        <div className="cats-all-btns-inner d-flex flex-wrap align-items-center justify-content-end">
                                                            {/* <button
                                                                onClick={() => {
                                                                    setShow(true)
                                                                }}
                                                                className="st-btn st-btn-primary-outlined no-min-width st-btn-sm d-flex align-items-center justify-content-center">
                                                                <FeatherIcon
                                                                    icon="plus-circle"
                                                                    size="14"
                                                                    className="icon me-2" />
                                                                <span>Add New</span>
                                                            </button> */}
                                                        </div>
                                                        <div className="cats-all-btns-right d-flex flex-wrap  justify-content-start align-items-center">
                                                            <button
                                                                onClick={formik.resetForm}
                                                                className={`st-btn st-btn-gray st-btn-sm d-flex align-items-center justify-content-center  me-2`}>
                                                                <FeatherIcon
                                                                    icon="rotate-cw"
                                                                    size="14"
                                                                    className="icon me-2" />
                                                                <span>Reset</span>
                                                            </button>
                                                            <button
                                                                onClick={handleFormSubmission}
                                                                type="submit"
                                                                className={`st-btn st-btn-primary  st-btn-sm d-flex align-items-center justify-content-center ${(editButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}>
                                                                {
                                                                    editButtonLoading ? (
                                                                        <Spinner animation="border" size="sm" />
                                                                    ) : (
                                                                        <>
                                                                            <FeatherIcon
                                                                                icon="download"
                                                                                size="14"
                                                                                className="icon me-2" />

                                                                            <span>Save</span>
                                                                        </>
                                                                    )}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </div>
                                        </Col>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </div >
            </Container >
        </section >
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(StoreMultiplier)